<template>
  <app-client-layout title="アンケート">
    <template #header>
      <h2 class="text-xl font-semibold leading-tight text-gray-800">
        アンケート
      </h2>
    </template>

    <div class="bg-white border-solid border border-gray-200 mx-auto max-w-4xl m-4 p-4">
      <h3 class="font-black mt-8 ml-4">1. 弊社のサービスをどこでお知りになりましたか？</h3>
      <Questionnaire
        name="q1"
        :options="options.q1options"
        @update-value="questionnaire.q1answer = $event" />

      <Questionnaire
        v-if="questionnaire.q1answer == 5"
        name="q1text"
        :is-free-form="true"
        @update-value="questionnaire.q1text = $event" />

      <h3 class="font-black mt-8 ml-4">2. 弊社サービスに対する満足度を教えてください。</h3>
      <Questionnaire
        name="q2"
        :options="options.q2options"
        @update-value="questionnaire.q2answer = $event" />

      <!-- <h3 class="font-black mt-8 ml-4">3. 模試の事前登録の値段(2,800円)について感想をお聞かせください。</h3>
      <Questionnaire
        name="q3"
        :options="options.q3options"
        @update-value="questionnaire.q3answer = $event"/> -->

      <h3 class="font-black mt-8 ml-4">3. 模試の通常の値段(4,000円)について感想をお聞かせください。</h3>
      <Questionnaire
        name="q4"
        :options="options.q4options"
        @update-value="questionnaire.q4answer = $event" />

      <h3 class="font-black mt-8 ml-4">4. 1年間で何回の模擬試験を希望しますか？</h3>
      <Questionnaire
        name="q5"
        :options="options.q5options"
        @update-value="questionnaire.q5answer = $event" />

      <h3 class="font-black mt-8 ml-4">5. 動物看護師としてのキャリアを充実させるために今後どのようなサービスを期待しますか？</h3>
      <Questionnaire
        name="q6"
        :is-check-box="true"
        :options="options.q6options"
        @update-checkbox-value="questionnaire.q6answer = $event" />

      <Questionnaire
        v-if="questionnaire.q6answer.find(el => el == 5)"
        name="q6text"
        :is-free-form="true"
        @update-value="questionnaire.q6text = $event" />

      <h3 class="font-black mt-8 ml-4">6. 弊社サービスに対するご意見・ご要望がありましたら、ご自由にお書きください。</h3>
      <Questionnaire
        name="q7"
        :is-free-form="true"
        @update-value="questionnaire.q7text = $event" />

      <div class="my-12 ml-2 border-t">
        <div class="mt-16 max-w-lg mx-auto items-center">
          <p class="text-center text-gray-600 font-medium">好評リリース中のモバイルアプリ</p>
          <img
            class="mx-auto w-auto"
            src="/images/zoo-logo.png">

          <div class="mt-4 text-gray-600 font-medium">
            <ul class="mb-8">
              <li class="list-disc mb-2">
                国家試験コアカリキュラムに準拠した愛玩動物看護師の演習問題を約800問用意
              </li>
              <li class="list-disc mb-2">
                科目、分野ごとにクイズ形式で学習可能
              </li>
              <li class="list-disc mb-2">
                体験模試と連携し、模試に出てきた問題も復習可能
              </li>
              <li class="list-disc mb-2">
                問題ごとの理解度設定や毎日の学習記録が付けられる
              </li>
              <li class="list-disc">
                正答率の傾向などから苦手な分野を分析し重点的に学習可能
              </li>
            </ul>
          </div>
        </div>
        <div class="md:flex mt-4">
          <img
            class="w-64 mx-auto"
            src="/images/portal-mobile-home.png">
          <img
            class="w-64 mx-auto"
            src="/images/portal-mobile-ready.png">
          <img
            class="w-64 mx-auto"
            src="/images/portal-mobile-practice.png">
        </div>

        <div class="flex justify-center space-x-20 mt-10">
          <div>
            <img
              class="mx-auto h-28 w-auto"
              src="/images/AnimalPortal_Android.png">
            <a
              class="underline"
              href="https://play.google.com/store/apps/details?id=com.vet.animal_portal&pli=1">Android版はこちら</a>
          </div>

          <div>
            <img
              class="mx-auto h-28 w-auto"
              src="/images/AnimalPortal_iOS.png">
            <a
              class="underline"
              href="https://apps.apple.com/jp/app/%E3%81%A9%E3%81%86%E3%81%B6%E3%81%A4%E7%9C%8B%E8%AD%B7%E3%83%9D%E3%83%BC%E3%82%BF%E3%83%AB/id1628987767">iOS版はこちら</a>
          </div>
        </div>
      </div>

      <div class="flex justify-center items-center">
        <button
          class="px-8 py-2 m-5 rounded bg-red-500 hover:bg-red-400 text-blue-50 max-w-max shadow-sm hover:shadow-lg"
          @click="onClickBackButton">
          戻る
        </button>
        <button
          class="px-8 py-2 m-5 rounded bg-blue-600 hover:bg-blue-400 text-blue-50 max-w-max shadow-sm hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
          :disabled="isBlankForm"
          @click="onClickCommentary()">
          解答し、解説に進む
        </button>
      </div>
    </div>
  </app-client-layout>
</template>

<script setup>
import moment from 'moment'
import { Inertia } from '@inertiajs/inertia'
import { ref, reactive, computed } from 'vue'
import Questionnaire from '../Partials/Questionnaire'
import AppClientLayout from '@/Layouts/AppClientLayout'

const props = defineProps({
  examination: {
    type: Object,
    default: () => {},
  },
})

const questionnaire = reactive({
  q1answer: 0,
  q1text: '',
  q2answer: 0,
  q3answer: 3,
  q4answer: 0,
  q5answer: 0,
  q6answer: [],
  q6text: '',
  q7text: '',
})

const options = reactive({
  q1options: [
    { label: 'Instagram', value: 1 },
    { label: 'チラシ', value: 2 },
    { label: 'インターネット検索', value: 3 },
    { label: '家族・友人・知人からの口コミ', value: 4 },
    { label: 'その他', value: 5 },
  ],
  q2options: [
    { label: '満足', value: 1 },
    { label: 'やや満足', value: 2 },
    { label: 'どちらとも言えない', value: 3 },
    { label: 'やや不満', value: 4 },
    { label: '不満', value: 5 },
  ],
  q3options: [
    { label: '高い', value: 1 },
    { label: 'やや高い', value: 2 },
    { label: '妥当', value: 3 },
    { label: 'やや安い', value: 4 },
    { label: '安い', value: 5 },
  ],
  q4options: [
    { label: '高い', value: 1 },
    { label: 'やや高い', value: 2 },
    { label: '妥当', value: 3 },
    { label: 'やや安い', value: 4 },
    { label: '安い', value: 5 },
  ],
  q5options: [
    { label: '1回', value: 1 },
    { label: '2-3回', value: 2 },
    { label: '4-5回', value: 3 },
    { label: '6回以上', value: 4 },
  ],
  q6options: [
    { label: '問題演習モバイルアプリ', value: 1 },
    { label: 'オンライン個別授業', value: 2 },
    { label: 'オンライン集団授業', value: 3 },
    { label: '就職・転職支援サービス', value: 4 },
    { label: 'その他', value: 5 },
  ],
})

const isBlankForm = computed(() => {
  let isBlank = false
  if (!questionnaire.q1answer
   || !questionnaire.q2answer
   || !questionnaire.q3answer
   || !questionnaire.q4answer
   || !questionnaire.q5answer) {
    isBlank = true
  } else if (parseInt(questionnaire.q1answer, 10) === 5 && !questionnaire.q1text) {
    isBlank = true
  } else if (questionnaire.q6answer.find(el => parseInt(el, 10) === 5) && !questionnaire.q6text) {
    isBlank = true
  }
  return isBlank
})

const onClickCommentary = () => {
  Inertia.post(route('questionnaire.update', {
    examination: props.examination.id,
    q1answer: questionnaire.q1answer,
    q1text: questionnaire.q1text,
    q2answer: questionnaire.q2answer,
    q3answer: questionnaire.q3answer,
    q4answer: questionnaire.q4answer,
    q5answer: questionnaire.q5answer,
    q6answer: questionnaire.q6answer,
    q6text: questionnaire.q6text,
    q7text: questionnaire.q7text,
  }))
}

const onClickBackButton = () => {
  Inertia.get(route('result'))
}
</script>

<style scoped>
  @import '../../../../css/heading.css';
</style>
